import React, { useState } from "react";
import "./MobileNavMenu.css";
import logo from "../../Images/Clariss-Logo.webp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faMagnifyingGlass,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import Cart from "../Cart/Cart";
import { Link } from "react-router-dom";
import PopCart from "../PopCart/PopCart";
import MobileSearch from "../MobileSearch/MobileSearch";
import MobileCategory from "../MobileCategory/MobileCategory"; // ✅ This will be renamed as "Shop"

const MobileNavMenu = ({ popCart, handlePopCart }) => {
  const [userLogin, setUserLogin] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [menu, setMenu] = useState(false);

  const handleUserLogin = () => {
    setUserLogin(!userLogin);
    setShowSearch(false);
  };

  const handleSearch = (search) => {
    setShowSearch(search);
  };

  const handleMenu = (menuState) => {
    setMenu(menuState);
    setShowSearch(false);
    if (menuState) {
      handlePopCart(false);
    }
  };

  // ✅ Prevent body scroll when menu/search/cart active
  if (popCart || userLogin || showSearch || menu) {
    if (window.innerWidth < 640) {
      document.body.style.overflow = "hidden";
    }
  } else {
    document.body.style.overflow = "visible";
  }

  return (
    <nav
      className={`mobile-menu-container ${
        showSearch ? "searched-nav-menu" : ""
      }`}
      aria-label="Clariss Food Mobile Navigation"
    >
      {/* ✅ Popup Cart */}
      <PopCart handlePopCart={handlePopCart} popCart={popCart} />

      <div className="flex">
        {/* ✅ Hamburger Menu renamed as SHOP for food categories */}
        <button
          className="text-secondary mr-8 text-xl"
          aria-label="Open Food Categories"
          onClick={() => handleMenu(true)}
        >
          <FontAwesomeIcon icon={faBars} />
        </button>

        {/* ✅ MobileCategory now acts as SHOP (food categories like oils, honey, canned food) */}
        <MobileCategory menu={menu} handleMenu={handleMenu} title="Shop" />

        {/* ✅ Search Button */}
        <button
          aria-label="Search Organic Food Products"
          onClick={() => handleSearch(!showSearch)}
          className="text-secondary text-xl"
        >
          <FontAwesomeIcon icon={faMagnifyingGlass} />
        </button>
        <MobileSearch showSearch={showSearch} handleSearch={handleSearch} />
      </div>

      {/* ✅ Logo links to homepage */}
      <Link to="/" aria-label="Clariss Food Homepage">
        <img
          className="w-[60%] mx-auto px-4"
          src={logo}
          alt="Clariss Bangladesh - Organic & Natural Food Products"
          width={200}
          height={80}
        />
      </Link>

      {/* ✅ Customer Dashboard */}
      <Link
        className="ml-auto"
        to="/customerDashboard"
        aria-label="Customer Dashboard"
      >
        <FontAwesomeIcon
          className="text-secondary text-2xl absolute right-16 bottom-[26px]"
          icon={faUser}
        />
      </Link>

      {/* ✅ Mobile Cart */}
      <div className="ml-auto">
        <Cart
          popCart={popCart}
          handlePopCart={handlePopCart}
          handleSearch={handleSearch}
        />
      </div>

      {/* ✅ Overlay when menu/search/cart active */}
      <span
        className={`overlay ${
          showSearch ? "searched-overlay" : "not-searched-overlay"
        } ${userLogin ? "overlay-active" : ""} ${
          popCart || menu ? "overlay-active " : ""
        }`}
        aria-hidden={!(showSearch || popCart || menu)}
      ></span>
    </nav>
  );
};

export default MobileNavMenu;
